module.exports = __webpack_public_path__ + "static/media/sabag_logo.f89f1ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sabag_logo.png
// module id = 1880
// module chunks = 0